import { isLink } from "./isLink";
import { $messageLoad, $messageContainer } from "../../common/message";

function initialize(): void {
  isLink();
  $messageLoad(1); // 通知cms已经加载完毕
  $messageContainer([{ name: "sk-cms-main" }]); // 通知cms当前默认主容器
  $cz.event("initialize");
}

export { initialize };
